import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/pc/home',
    name: 'pc端首页',
    component: () => import('../views/pc/home.vue'),
  },
  {
    path: '/pc/product',
    name: 'pc端产品页',
    component: () => import('../views/pc/product.vue'),
  },
  {
    path: '/pc/contact',
    name: 'pc端联系我们',
    component: () => import('../views/pc/contact.vue'),
  },
  {
    path: '/mb/home',
    name: 'h5首页',
    component: () => import('../views/mb/home.vue'),
  },
  {
    path: '/mb/product',
    name: 'h5产品页',
    component: () => import('../views/mb/product.vue'),
  },
  {
    path: '/mb/contact',
    name: 'h5联系我们',
    component: () => import('../views/mb/contact.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_API,
  routes
})

export default router
